import "./App.css";
import { history } from "./history";
import { Router, Switch, Route } from "react-router-dom";
import React, { lazy, Suspense, Component } from "react";
import Header from "./components/Header";
import Sidebar from "./components/SideBar/Sidebar";
import { DieselRequestList } from "./components/FuelReports/dieselRequestList";
import CheckDropList from "./components/FuelReports/CheckDropList";
// import { PrivateRoute } from './route/privateRoute';
const Login = lazy(() => import("./components/Login"));
const UserList = lazy(() => import("./components/UserManagement/userList"));
const AddUser = lazy(() => import("./components/UserManagement/addUser"));
const Users = lazy(() => import("./components/UserManagement/viewUser"));
const SubUserList = lazy(
  () => import("./components/UserManagement/SubUserManagement/subUserList"),
);
const FMSDashboard = lazy(
  () => import("./components/Dashboard/FMSdashboard/fms-dashbard"),
);

const DeviationList = lazy(
  () => import("./components/FuelReports/deviationList"),
);
const AddSubUser = lazy(
  () => import("./components/UserManagement/SubUserManagement/addSubUser"),
);
const SubUsers = lazy(
  () => import("./components/UserManagement/SubUserManagement/viewSubUser"),
);
const CompanyList = lazy(
  () => import("./components/CompanyManagement/companyList"),
);
const AddCompany = lazy(
  () => import("./components/CompanyManagement/addCompany"),
);
const AddSite = lazy(() => import("./components/Site/addSite"));
const VehicleList = lazy(
  () => import("./components/VehicleManagement/vehicleList"),
);
const AdvanceSettings = lazy(
  () => import("./components/VehicleManagement/AdvanceSettings"),
);
const Settings = lazy(() => import("./components/VehicleManagement/Settings"));
const AddVehicle = lazy(
  () => import("./components/VehicleManagement/addVehicle"),
);
const VendorList = lazy(
  () => import("./components/VendorManagement/vendorList"),
);
const AddVendor = lazy(() => import("./components/VendorManagement/addVendor"));
const Vehicles = lazy(
  () => import("./components/VehicleManagement/viewVehicle"),
);
const Vendors = lazy(() => import("./components/VendorManagement/viewVendor"));
const RouteList = lazy(() => import("./components/RouteManagement/routeList"));
const AddRoute = lazy(() => import("./components/RouteManagement/addRoute"));
const ViewRoute = lazy(() => import("./components/RouteManagement/viewRoute"));
const TripList = lazy(() => import("./components/TripManagement/tripList"));
const ViewTrip = lazy(() => import("./components/TripManagement/viewTrip"));
const AddTrip = lazy(() => import("./components/TripManagement/AddTrip"));
const MenuPermission = lazy(
  () => import("./components/MenuPermission/MenuPermission"),
);
const Reports = lazy(() => import("./components/Reports/report"));
const SiteManagement = lazy(() => import("./components/Site/siteManagement"));
const ViewUser = lazy(() => import("./components/Site/viewUser"));
const LiveTracking = lazy(() => import("./components/Tracking/live"));
const HistoryTracking = lazy(() => import("./components/Tracking/history"));
const Dashboard = lazy(() => import("./components/Dashboard/dashboard"));
const AllReportPage = lazy(
  () => import("./components/ReportsGps/AllReportPage"),
);
const FuelReport = lazy(() => import("./components/FuelReports/report"));
// const FuelDashboard = lazy(() => import("./components/FuelReports/dashboard"));
const FuelDashboard = lazy(
  () => import("./components/FuelReports/fuelDashboard"),
);
const KMLView = lazy(() => import("./components/kmlFile/index"));
const Alerts = lazy(() => import("./components/Alerts/index"));
const SummaryReportPage = lazy(
  () => import("./components/ReportsGps/SummaryReportPage"),
);
const MovementReportPage = lazy(
  () => import("./components/ReportsGps/Movement"),
);
const StopReportPage = lazy(
  () => import("./components/ReportsGps/StopReportPage"),
);
const tripMap = lazy(() => import("./components/TripManagement/tripMaps"));
const ReportMapDetails = lazy(
  () => import("./components/Reports/reportMapDetails"),
);
const FuelVehicleDetail = lazy(
  () => import("./components/FuelReports/fuelVehicleDetail"),
);
const SensorWirecut = lazy(
  () => import("./components/FuelReports/SensorWirecut"),
);
const NotificationConfiguration = lazy(
  () => import("./components/ConfigureManagement/Notification_Configuration"),
);
const AddNotification = lazy(
  () =>
    import("./components/ConfigureManagement/add_notication/Add_Notification_Configuration"),
);
const Dieselissue = lazy(() => import("./components/FuelReports/Diesel_issue"));
const ReportSettingConfig = lazy(
  () => import("./components/FuelReports/reportConfigSetting"),
);

const Requste = lazy(() => import("./components/FuelReports/Requester"));
const RoleList = lazy(() => import("./components/SideBar/RoleList/Rolelist"));
const FuelCalibrationReports = lazy(
  () => import("./components/FuelCalibartionReports/FuelCalibrationReports"),
);
const LiveTrackingMap = lazy(
  () => import("./components/TripManagement/ManualTripTracking"),
);
const FuelFillDropGenerate = lazy(
  () => import("./components/FuelReports/fillDropGeenerate"),
);

const EquipmentUtilization = lazy(
  () => import("./components/ReportsGps/EquipmentUtilization"),
);

const DailySummaryReportPage = lazy(
  () => import("./components/ReportsGps/DailySummaryReportPage"),
);
const EfficienclyReports = lazy(
  () => import("./components/ReportsGps/EfficienclyReports"),
);

const DriverAttendance = lazy(
  () => import("./components/DriverAttendance/index"),
);
const GeoFenceInoutReport = lazy(
  () => import("./components/ReportsGps/GeoFenceInOutereport"),
);
const EquipmentReports = lazy(
  () => import("./components/ReportsGps/EquipmentReports"),
);
const LockDashboard = lazy(
  () => import("./components/LockDashBoard.js/LockDashboard"),
);
const LoadSensorReports = lazy(
  () => import("./components/ReportsGps/LoadSensorReports"),
);
const LockInventory = lazy(
  () => import("./components/LockInventory/LockInventory"),
);
const AlertList = lazy(() => import("./components/AlertManagement/AlertList"));

class App extends Component {
  render() {
    return (
      <main className="App">
        <Router history={history}>
          {window.location.pathname !== "/" &&
            window.location.pathname !== "/alerts" && (
              <>
                <Header />
                <Sidebar />
              </>
            )}

          <Suspense fallback={<div>Loading</div>}>
            <Switch>
              <Route exact path="/" component={Login} />
              <Route exact path="/userlist" component={UserList} />
              <Route exact path="/adduser" component={AddUser} />
              <Route exact path="/users/:id?" component={Users} />
              <Route exact path="/subuserlist" component={SubUserList} />
              <Route exact path="/addsubuser" component={AddSubUser} />
              <Route exact path="/subusers/:id" component={SubUsers} />
              <Route exact path="/companylist" component={CompanyList} />
              <Route exact path="/addcompany" component={AddCompany} />
              <Route exact path="/vehiclelist" component={VehicleList} />
              <Route
                exact
                path="/advance-settings"
                component={AdvanceSettings}
              />
              <Route exact path="/addvehicle" component={AddVehicle} />
              <Route exact path="/vehicles/:id?" component={Vehicles} />
              <Route exact path="/settings/:id?" component={Settings} />
              <Route exact path="/transporters/:id?" component={Vendors} />
              <Route exact path="/transporterlist" component={VendorList} />
              <Route exact path="/addtransporter" component={AddVendor} />
              <Route exact path="/routelist" component={RouteList} />
              <Route exact path="/addroute" component={AddRoute} />
              <Route exact path="/routes/:id?" component={ViewRoute} />
              <Route exact path="/triplist" component={TripList} />
              <Route exact path="/addtrip" component={AddTrip} />
              <Route
                exact
                path="/driverAttendance"
                component={DriverAttendance}
              />
              <Route exact path="/trips/:id?" component={ViewTrip} />
              <Route exact path="/menuPermission" component={MenuPermission} />
              <Route exact path="/reports" component={Reports} />
              <Route exact path="/sitelist" component={SiteManagement} />
              <Route exact path="/viewUser/:id?" component={ViewUser} />
              <Route exact path="/site/:id?" component={AddSite} />
              <Route exact path="/addSite" component={AddSite} />
              <Route exact path="/live/:id?" component={LiveTracking} />
              <Route exact path="/history/:id?" component={HistoryTracking} />
              <Route exact path="/dashboard" component={Dashboard} />
              <Route exact path="/Reportsgps" component={AllReportPage} />
              <Route exact path="/fuelReport" component={FuelReport} />
              <Route
                exact
                path="/reportConfig"
                component={ReportSettingConfig}
              />
              <Route exact path="/kmlview" component={KMLView} />
              <Route exact path="/alerts" component={Alerts} />
              <Route exact path="/Summary" component={SummaryReportPage} />
              <Route exact path="/Movement" component={MovementReportPage} />
              <Route exact path="/Stoppage" component={StopReportPage} />
              <Route exact path="/reportDetails" component={ReportMapDetails} />
              <Route exact path="/tripTrack/:id?" component={tripMap} />
              <Route exact path="/audit" component={Reports} />
              <Route exact path="/activeRoutes" component={Reports} />
              <Route exact path="/upTime" component={Reports} />
              <Route
                exact
                path="/fuelDetails/:id?"
                component={FuelVehicleDetail}
              />
              <Route
                exact
                path="/notificationConfigure"
                component={NotificationConfiguration}
              />
              <Route
                exact
                path="/addNotification"
                component={AddNotification}
              />
              <Route
                exact
                path="/viewNotification/:id?"
                component={AddNotification}
              />
              <Route exact path="/SensorWirecut" component={SensorWirecut} />
              <Route exact path="/Diesel_issue" component={DieselRequestList} />
              {/* <Route exact path="/Requester" component={Requester} /> */}
              <Route exact path="/rolelist" component={RoleList} />
              <Route
                exact
                path="/fuelDashboardDetails"
                component={FuelDashboard}
              />
              {/* <Route
                exact
                path="/fuelDashboard"
                component={FMSDashboard}
              /> */}
              <Route exact path="/fuelDashboard" component={FuelDashboard} />
              <Route
                exact
                path="/fuelCalibrationReports"
                component={FuelCalibrationReports}
              />
              <Route exact path="/deviationMaster" component={DeviationList} />
              <Route
                exact
                path="/manualTripTracking/:id?"
                component={LiveTrackingMap}
              />
              <Route
                exact
                path="/manualFuelEvents/:id?"
                component={FuelFillDropGenerate}
              />
              <Route
                exact
                path="/equipmentUtilization/:id?"
                component={EquipmentUtilization}
              />
              <Route
                exact
                path="/DailyDistance"
                component={DailySummaryReportPage}
              />
              <Route exact path="/AlertList" component={AlertList} />

              <Route
                exact
                path="/EfficiencyReports/:id?"
                component={EfficienclyReports}
              />
              <Route exact path="/geofence" component={GeoFenceInoutReport} />
              <Route exact path="/equipment" component={EquipmentReports} />
              <Route exact path="/geofence" component={GeoFenceInoutReport} />
              <Route exact path="/lockDashboard" component={LockDashboard} />
              <Route exact path="/bulkerReport" component={LoadSensorReports} />
              <Route exact path="/lockInventory" component={LockInventory} />
            </Switch>
          </Suspense>
        </Router>
      </main>
    );
  }
}
export default App;
